/* eslint-disable no-unused-vars */
import React from "react";
import * as styles from "./Location.module.css";
import enchantedLogo from "../../../images/on-going-projects/enchanted/Logos/enchanted-logo-1.png";
import dotsIcon from "../../../images/on-going-projects/enchanted/Icons/dots-icon.png";

function Location() {
  return (
    <div className={styles.locationContainer} id="location">
      <h1>
        <img loading="lazy"  src={dotsIcon} alt="dots-icon" className={styles.dotsIcon} />
        Location
      </h1>
      <div className={styles.googleMapsIframeContainer}>
      {/* <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3888.3548752940396!2d80.24531549999999!3d12.949129!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a525d00061a92dd%3A0x63907e5fe03eadbe!2sEnchanted%20-%20Baashyaam%20Group!5e0!3m2!1sen!2sin!4v1754015834941!5m2!1sen!2sin" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe> */}
        <iframe
          title="google map"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3888.3548752940396!2d80.24531549999999!3d12.949129!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a525d00061a92dd%3A0x63907e5fe03eadbe!2sEnchanted%20-%20Baashyaam%20Group!5e0!3m2!1sen!2sin!4v1754015834941!5m2!1sen!2sin"
          allowfullscreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
        <div className={styles.logoContainer}>
          <img loading="lazy"  alt="" src={enchantedLogo} className={styles.asset1} />
          {/* <span className={styles.addressText}>
            Plot No A, Old Door No.15 Part, Present Door No 8/1, Boat Club Road,
            Raja Annamalaipuram, <br />
            Chennai-600 028.
          </span> */}
        </div>
      </div>
    </div>
  );
}

export default Location;
